
import React from "react";
import { useState, useEffect } from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import { openPopup } from "../../stateManagement/actions/popupActions";
import { DeliveryInvoiceBatchDetails, SalesReasonDetails } from "../../types/types";
import { useLocation } from "react-router-dom";
import { batch } from "react-redux";
import DeliveryInvoiceReasonSelection from "../deliveryInvoiceEdit/DeliveryInvoiceReasonSelection";
import { PrimaryReturnBatchDetails } from "./PrimaryReturnEdit";
import PrimaryReturnReasonSelect from "./PrimaryReturnReasonSelect";
import { QuantityReason } from "./PrimaryReturnUtils";


const PrimaryReturnReasonSelectParent = (props: {errorObj: any, batchData: PrimaryReturnBatchDetails, ignoreValidation?: boolean, updateParent?: () => void , selectedQuantity: string, productDetails?: any}) => {
  const location: { state: any } = useLocation();

  const defaultReasonMap = {
    "ACCEPTED": [{
      caseQty: 0, pieceQty: 0, reason: "", otherQty: 0
    }],
    "REJECTED": [{
      caseQty: 0, pieceQty: 0, reason: props.batchData.rejectionReason ?? "", otherQty: 0
    }]
  }

  const [currentErrorObj, setCurrentErrorObj] = useState<any>();

  useEffect(() => {
    if (props.errorObj && props.selectedQuantity) setCurrentErrorObj(props.errorObj[props.selectedQuantity]);
  }, [props.errorObj, props.selectedQuantity]);

  const [reasonMap, setReasonMap] = useState<Record<string, QuantityReason[]>>(defaultReasonMap);

  useEffect(() => {
    if (!props.batchData.reasonDetails || Object.keys(props.batchData.reasonDetails).length === 0) {
      setReasonMap({...defaultReasonMap})
    } else {
      setReasonMap({...props.batchData.reasonDetails})
    }
  }, [props.batchData, props.selectedQuantity])
  
  useEffect(() => {
    props.batchData.reasonDetails = reasonMap;
  }, [reasonMap]);

  const convertToPieceQty = (qty: number, key: "pieceQty" | "caseQty" | "otherQty") => {
    switch (key) {
      case "pieceQty": return qty;
      case "caseQty": return props.productDetails ? props.productDetails.caseToPieceQuantity * qty : qty;
      case "otherQty": return props.productDetails ? props.productDetails.otherUnitToPieceQuantity * qty : qty;
    }
  }

  const getNormalisedQty = (caseQty: number, pieceQty: number, otherQty: number) => {
    let qty = pieceQty;
    qty += props.productDetails ? props.productDetails.caseToPieceQuantity * caseQty : caseQty;
    qty += props.productDetails ? props.productDetails.otherUnitToPieceQuantity * otherQty : otherQty;
    return qty;
  }

  const getCurrentAggregatedNormalisedQty = (reasonList: QuantityReason[]) => {
    const prevAggQty = reasonList.reduce((acc, curr) => acc + getNormalisedQty(curr.caseQty, curr.pieceQty, curr.otherQty), 0);
    return prevAggQty;
  }

  const validateQuantity = (qty: number, prevQty: number, key: "pieceQty" | "caseQty" | "otherQty") => {
    if (props.ignoreValidation) {
      return true;
    }

    if (props.selectedQuantity === "ACCEPTED"){
      const allowedQty = getNormalisedQty(props.batchData.acceptableCaseQty, props.batchData.acceptablePieceQty, props.batchData.acceptableOtherQty);
      const currentQty = getCurrentAggregatedNormalisedQty(reasonMap[props.selectedQuantity]) + convertToPieceQty(qty, key) - convertToPieceQty(prevQty, key);
      if (currentQty > allowedQty) {
        openPopup("Error", "Return quantity cannot exceed Accepted returnable quantity");
        return false
      }
      return true
    } else {
      const allowedQty = getNormalisedQty(props.batchData.rejectableCaseQty, props.batchData.rejectablePieceQty, props.batchData.rejectableOtherQty);
      const currentQty = getCurrentAggregatedNormalisedQty(reasonMap[props.selectedQuantity]) + convertToPieceQty(qty, key) - convertToPieceQty(prevQty, key);
      if (currentQty > allowedQty) {
        openPopup("Error", "Return quantity cannot exceed Rejected returnable quantity");
        return false
      }
      return true
    }
  }

  const removeIcon = (index:number)=>{
    return <RemoveCircleOutlineIcon
    onClick={() => {
      const newList = [...(reasonMap[props.selectedQuantity] ?? [])];
      newList.splice(index, 1);

      if (newList.length === 0) {
        setReasonMap(defaultReasonMap);
      } else {
        setReasonMap((prev) => {
          return {
            ...prev,
            [props.selectedQuantity]: newList,
          };
        });
      }
    }}
    style={{
      cursor: "pointer",
      color: "#C44C36",
    }}
  />
  }

  const addIcon = ()=>{
    return <AddCircleOutlineIcon
      style={{
        cursor: "pointer",
        color: "#227C9D",
        strokeWidth: 2,
      }}
      onClick={() => {
        const newList = [...reasonMap[props.selectedQuantity]];
        newList.push({ reason: "", caseQty: 0, pieceQty: 0, otherQty: 0 });

        setReasonMap((prev) => {
          return {
            ...prev,
            [props.selectedQuantity]: newList,
          };
        });

      }}
    />
  }

  return (
    <div className="delivery-reasons-container" style={{padding: "0px", overflowX: "hidden", scrollbarWidth: "thin"}}>
      {reasonMap[props.selectedQuantity].map((reason: QuantityReason, index: number) => {
        return (

          <div className="delivery-sku-edit-list-item" key={index}>
          <PrimaryReturnReasonSelect currentErrorObj={currentErrorObj?.[index]} selectedQuantity={props.selectedQuantity} products={props.productDetails} validate={validateQuantity} reasonObject={reason} actionElement={reasonMap[props.selectedQuantity].length >= 2 ? removeIcon(index) : addIcon()} onChange={(data: QuantityReason ) => {
              const newReasonList = [...reasonMap[props.selectedQuantity]];
              newReasonList[index].pieceQty = data.pieceQty ?? 0;
              newReasonList[index].caseQty = data.caseQty ?? 0;
              newReasonList[index].otherQty = data.otherQty ?? 0;
              newReasonList[index].reason = data.reason ?? "";

              setReasonMap((prev) => {
                return {
                  ...prev,
                  [props.selectedQuantity]: newReasonList,
                };
              });
            }} 
          />
          </div>

        );
      })}
      <div className="delivery-batch-edit-add-more" style={{marginTop:"0px"}}>
        {reasonMap[props.selectedQuantity].length >= 2 && addIcon()}
      </div>
    </div>
  );
}

export default PrimaryReturnReasonSelectParent;
